const range = (start, end) => Array.from({ length: Math.max(end - start + 1, 0) }, (_, i) => start + i);
/**
 * Computes the ordered list of page slots to render, collapsing long runs into
 * `'ellipsis'` gaps while always keeping the first/last `boundaryCount` pages and
 * `siblingCount` pages on either side of the current page. Mirrors the well-known
 * MUI `usePagination` logic.
 *
 * @param page          Current page (1-based).
 * @param count         Total number of pages.
 * @param siblingCount  Pages shown on each side of the current page. Default 1.
 * @param boundaryCount Pages always shown at the start and end. Default 1.
 */
export const getPaginationRange = (page, count, siblingCount = 1, boundaryCount = 1) => {
    if (count <= 0) {
        return [];
    }
    const startPages = range(1, Math.min(boundaryCount, count));
    const endPages = range(Math.max(count - boundaryCount + 1, boundaryCount + 1), count);
    const siblingsStart = Math.max(Math.min(page - siblingCount, count - boundaryCount - siblingCount * 2 - 1), boundaryCount + 2);
    const siblingsEnd = Math.min(Math.max(page + siblingCount, boundaryCount + siblingCount * 2 + 2), endPages.length > 0 ? endPages[0] - 2 : count - 1);
    return [
        ...startPages,
        // Gap or a single page between the start boundary and the sibling range.
        ...(siblingsStart > boundaryCount + 2
            ? ['ellipsis']
            : boundaryCount + 1 < count - boundaryCount
                ? [boundaryCount + 1]
                : []),
        ...range(siblingsStart, siblingsEnd),
        // Gap or a single page between the sibling range and the end boundary.
        ...(siblingsEnd < count - boundaryCount - 1
            ? ['ellipsis']
            : count - boundaryCount > boundaryCount
                ? [count - boundaryCount]
                : []),
        ...endPages,
    ];
};
//# sourceMappingURL=pagination_range.js.map